import { createContext } from 'react';
import { defaultFormContext } from '../Form/FormContext';

export const FormFieldLayoutContext = createContext(defaultFormContext);
